export const ru = {
    today: 'Сегодня',
    tomorrow: 'Завтра',
    yesterday: 'Вчера'
};
